import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { v4 as uuidv4 } from "uuid";


const Analytics_faq = () => {
    const webDevelopmentFAQs = [
        {
          "id": uuidv4(),
          "question": "What is Business Intelligence (BI), and how does it differ from regular reporting?",
          "answer": " Business Intelligence involves the use of data analysis tools and techniques to gain actionable insights, whereas reporting typically focuses on presenting data. BI goes beyond static reports, providing interactive and dynamic analytics for better decision-making."
        },
        {
          "id": uuidv4(),
          "question": "How can BI Analytics benefit my organization?",
          "answer": "BI Analytics can offer several advantages, including improved decision-making, enhanced operational efficiency, identification of business trends, and the ability to monitor key performance indicators (KPIs) in real-time. It empowers organizations to make data-driven decisions for strategic growth."
        },
        {
          "id": uuidv4(),
          "question": "What types of data sources can be integrated into BI Analytics platforms?",
          "answer": "BI Analytics platforms are designed to integrate data from diverse sources such as databases, spreadsheets, cloud applications, and external APIs. This flexibility allows organizations to create a unified view of their data for comprehensive analysis."
        },
        {
          "id": uuidv4(),
          "question": "How can non-technical users leverage BI Analytics tools for data analysis?",
          "answer": "Many BI Analytics tools offer user-friendly interfaces and self-service capabilities, enabling non-technical users to create reports, dashboards, and conduct analyses without the need for extensive IT support. Training and support resources are often available to assist users in maximizing the tool's potential."
        },
        {
          "id": uuidv4(),
          "question": "What role does predictive analytics play in Business Intelligence?",
          "answer": "Predictive analytics within BI involves using statistical algorithms and machine learning models to forecast future trends based on historical data. This capability helps organizations anticipate outcomes, identify patterns, and make proactive decisions for strategic planning."
        }
      ]
      return (
        <div className='px-5 sm:px-60 mt-10' id="faq">
          <p className='text-[#333e49] text-center font-notosans text-2xl sm:text-4xl font-bold m-10'>Frequently Asked Questions</p>
          {
            webDevelopmentFAQs.map((item) => 
        <Accordion key={item.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className='font-notosans font-bold'
          >
            {item.question}
          </AccordionSummary>
          <AccordionDetails className='font-notosans'>
            {item.answer}
          </AccordionDetails>
        </Accordion>
            )
          }
      </div>
      )
}

export default Analytics_faq